<template>
  <AppDeleteModal
    :loading="loading"
    :show="show"
    data-auto-testid="delete-user-without-groups-modal"
    :title="resolvedTitle"
    keypath="confirm.user.message"
    @on-confirm="onConfirm"
    @on-close="onClose"
  >
    <template #app-delete-modal:content>
      <slot />
    </template>
  </AppDeleteModal>
</template>

<script>
import { defineComponent } from 'vue'

import AppDeleteModal from '@/components/ui/AppDeleteModal/AppDeleteModal'

export default defineComponent({
  name: 'UserDeleteModal',

  components: {
    AppDeleteModal
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    title: {
      type: String,
      default: ''
    },

    loading: {
      type: Boolean
    }
  },

  emits: { 'on-confirm': null, 'on-close': null },

  computed: {
    resolvedTitle() {
      return this.title || this.$t('delete_user.title')
    }
  },

  methods: {
    onClose() {
      this.$emit('on-close')
    },

    onConfirm() {
      this.$emit('on-confirm')
    }
  }
})
</script>

<style lang="scss" scoped></style>
